import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const reloadSO = createAsyncThunk(
  "userAuthentication/reloadSourceOrganization",
  async (data, { rejectWithValue }) => {
    try {
      const timeout = () => {
        return new Promise((resolve) => setTimeout(resolve, 800));
      };
      await timeout(); 
      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default reloadSO;
